import React from "react";
import { cn } from "../../lib";

export interface ICCheckboxProps {
  label?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  checkboxClassName?: string;
  labelClassName?: string;
  disabled?: boolean;
  required?: boolean;
}

const ICCheckbox: React.FC<ICCheckboxProps> = ({
  label,
  checkboxClassName,
  labelClassName,
  disabled = false,
  required = false,
  checked,
  onChange,
}) => {
  const handleChange = () => {
    onChange(!checked);
  };

  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        className={cn(`size-5 accent-accent-emphasis rounded-md `, {
          [`${checkboxClassName}`]: checkboxClassName,
          "cursor-pointer": !disabled,
        })}
        checked={checked}
        disabled={disabled}
        onChange={() => (!disabled ? handleChange() : {})}
      />
      {label && (
        <label
          onClick={() => (!disabled ? handleChange() : {})}
          className={cn(`ms-2 cursor-pointer`, labelClassName)}
        >
          {label + (required ? "*" : "")}
        </label>
      )}
    </div>
  );
};

export default ICCheckbox;
